import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import BrokerCards from './BrokerCards'
import BrokerComparisonTable from './BrokerComparisonTable'
import HowTo from './HowTo'
import { history } from "../../../store"
import { COMPONENT_IDS } from '../common/common'

import { logPageView } from '../../../utils/emfLogs'
import { Pages } from '../../../utils/loggerConstants'
import { pageLoadLogs } from '../../../utils/loggerUtils'

import { Col, Container } from '@amzn/stencil-react-components/layout'

export class Broker extends Component {

  componentDidMount(){
    logPageView(Pages.Broker);
    pageLoadLogs(Pages.Broker, this.props.employee);

    if (history.location.state?.buttonNav) {
      document.getElementById(COMPONENT_IDS.FirstBrokerCard)?.focus();
    }
  }

  render() {
    const{ t } = this.props;

    return (
      <Container>
        <Col dataTestId="broker_test_id" gridGap="S500">
          <BrokerCards/>
          <HowTo/>
          <BrokerComparisonTable/>
        </Col>
      </Container>
    );
  }
}

const mapState = (state) => ({
  employee: state.employee
});

export default connect(mapState)(withTranslation('translationsV2')(Broker));
